module.exports = __webpack_public_path__ + "media/1.478291da.mp3";